import { defineStore } from "pinia";
import salesCardIcon from "@/assets/images/layout/sales-card-icon.svg";
import monthlySalesIcon from "@/assets/images/layout/green-package.svg";
import grayUpgrade from "@/assets/images/layout/up-grade.svg";
import apiClient from "@/core/buildRequest";

export const useGpStore = defineStore("gp", {
  state: () => ({
    gpData: null,
    loading: false,
    tableItems: [],
    gpCardsTotal: [
      {
        id: 1,
        key: "total_revenue",
        title: "Total Revenue",
        icon: salesCardIcon,
        bgColor: "#eff4ff",
        alt: "sales icon",
        value: "0",
        iconSarStatus: true,
      },
      {
        id: 2,
        key: "total_cost",
        title: "Total Cost",
        icon: monthlySalesIcon,
        bgColor: "#eff4ff",
        alt: "sales icon",
        value: "0",
        iconSarStatus: true,
      },
      {
        id: 4,
        key: "gp_amount",
        title: "Growth profit value",
        icon: grayUpgrade,
        bgColor: "#eff4ff",
        alt: "sales icon",
        value: "0",
        iconSarStatus: true,
      },
      {
        id: 3,
        key: "gp_percentage",
        title: "GP  %",
        icon: salesCardIcon,
        bgColor: "#eff4ff",
        alt: "sales icon",
        value: "0",
        iconSarStatus: false,
      },
    ],
    tabs: [],
    activeTab: null,
    pagination: {
      total_items: 0,
      current_page: 1,
      total_pages: 1,
    },
  }),

  actions: {
    async fetchGpData(params = {}) {
      this.loading = true;
      try {
        const response = await apiClient.get("gp", { params });
        const data = response.data.data;

        // Check if this is a "Global" fetch (no filters applied)
        const isGlobalFetch = !params.vendor_id && !params.sd;

        if (isGlobalFetch) {
          this.gpData = data;

          // Update cards
          this.gpCardsTotal = this.gpCardsTotal.map((card) => ({
            ...card,
            value: data.cards[card.key] || "0",
          }));

          // Update tabs list only if it's empty or global fetch
          if (data.vendor_tabs && (this.tabs.length === 0 || isGlobalFetch)) {
            this.tabs = data.vendor_tabs.map((tab) => ({
              value: tab.vendor_id.toString(),
              title: tab.vendor_name,
            }));

            if (!this.activeTab && this.tabs.length > 0) {
              this.activeTab = this.tabs[0].value;
            }
          }
        }

        // Always update table data and pagination
        if (data.table) {
          this.tableItems = data.table.items || [];
          if (data.table.pagination) {
            this.pagination = data.table.pagination;
          }
        }

        return data;
      } catch (error) {
        console.error("Error fetching GP data:", error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
});
